import React from "react";
import DummyChart from "../../../components/DummyChart";

/**
 * Growth Engine metric card — similar look to Artist Manager locks.
 * Link artist first when no profile, then subscribe to unlock DSP metrics.
 */
export default function GrowthEngineMetricCard({
    locked = false,
    lockIcon = null,
    lockLabel = "",
    lockPreviewValue = "—",
    lockChartType = "area",
    lockChartHeight = 200,
    showLinkArtistCta = false,
    showSubscribeCta = false,
    onSubscribe,
    onLinkArtist,
    children,
}) {
    const cardClass =
        "info-box relative flex h-full flex-col justify-between gap-2 overflow-hidden rounded-xl bg-white p-4 font-manrope 2xl:p-5";

    if (!locked) {
        return <div className={cardClass}>{children}</div>;
    }

    const showCta = showLinkArtistCta || showSubscribeCta;

    return (
        <div className={cardClass}>
            <DummyChart
                variant="metricCard"
                icon={lockIcon}
                chartType={lockChartType}
                chartHeight={lockChartHeight}
                topText={lockPreviewValue}
                bottomText={lockLabel}
                onProClick={showLinkArtistCta ? onLinkArtist : onSubscribe}
                showCta={showCta}
                ctaLabel={showLinkArtistCta ? "Link Your Artist" : "Subscribe to unlock"}
                showCtaIcon={!showLinkArtistCta}
                compactCta
            />
        </div>
    );
}
